// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"20bd7d84","578":"d812d135"}[chunkId] + ".chunk.js";
};